enum ComponentSizes {
	HeaderHeight = '60px',
	ToastWidth = 'min(100%, 520px)',
}

export default ComponentSizes;
